module.exports = __webpack_public_path__ + "img/logo-dev.06ffd921.png";